import { HStack, Text, useDisclosure } from '@chakra-ui/react';

import Button from '../../../../../components/ui/buttons/Button';
import { LDFlags } from '../../../../../constants/flags';
import { useFlag } from '../../../../../hooks';
import { MarketplaceOffer } from '../live/offers/utils';
import DelistModal from './DelistModal';

type DelistFooterProps = {
  externalId: string;
  offers?: MarketplaceOffer[];
  actionLabel?: string;
};

const DelistFooter = ({
  externalId,
  offers,
  actionLabel = 'Delist my vehicle',
}: DelistFooterProps) => {
  const delistEnabled = useFlag(LDFlags.MARKETPLACE_DELIST);
  const delistModal = useDisclosure();

  if (!delistEnabled) return null;

  return (
    <>
      <HStack justify="center" spacing={1.5} fontSize="13px" color="gray.500">
        <Text>No longer selling?</Text>
        <Button
          variant="link"
          onClick={delistModal.onOpen}
          trackClick="marketplace_delist"
          color="leaseEndRed"
          fontWeight="600"
          fontSize="13px"
          h="auto"
          p="4px"
          _hover={{ textDecoration: 'underline' }}
        >
          {actionLabel}
        </Button>
      </HStack>
      <DelistModal
        key={externalId}
        isOpen={delistModal.isOpen}
        onClose={delistModal.onClose}
        externalId={externalId}
        offers={offers}
      />
    </>
  );
};

export default DelistFooter;
